import { styled } from '@wandb/ui'

export const InfoSection = styled.div`
  margin: ${p => p.theme.spacing(4, 0)};
`
